import React from 'react';
import { Message } from '../types';

interface TranscriptViewProps {
  messages: Message[];
}

/**
 * TranscriptView Component
 * Renders a conversation transcript in a chat-like format
 */
const TranscriptView: React.FC<TranscriptViewProps> = ({ messages }) => {
  if (!messages || messages.length === 0) {
    return (
      <div className="text-center text-gray-500 py-8">
        No transcript available for this call.
      </div>
    );
  }

  const formatTimestamp = (seconds: number | null | undefined) => {
    if (seconds === null || seconds === undefined) return '0:00';
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = Math.floor(seconds % 60);
    return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
  };

  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold text-gray-800 mb-4">Conversation Transcript</h3>
      <div className="space-y-3">
        {messages.map((message, index) => (
          <div
            key={index}
            className={`flex ${message.role === 'user' ? 'justify-end' : 'justify-start'}`}
          >
            <div
              className={`max-w-xs lg:max-w-md px-4 py-2 rounded-lg ${
                message.role === 'user'
                  ? 'bg-blue-200 text-blue-900'
                  : 'bg-gray-200 text-gray-900'
              }`}
            >
              <div className="flex items-center justify-between mb-1">
                <span className="text-xs font-medium">
                  {message.role === 'user' ? 'Customer' : 'AI Assistant'}
                </span>
                <span className="text-xs text-gray-600">
                  {formatTimestamp(message.seconds_from_start)}
                </span>
              </div>
              <p className="text-sm">{message.content}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TranscriptView;